/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
  TwoColumns,
  IconButton,
} from '../../../services/settings/appStyle/global.style';
import {
  Table,
  IconButton as IconButtonWithText,
  Loader,
  TabButton,
} from '../../../Components/uielements';
import GroupIcon from '@mui/icons-material/Group';
import CheckIcon from '@mui/icons-material/Check';
import { useUserContext } from '../../../hooks/UserContext';
import LogbookService from '../../../services/bioplus-services/logBook';
import DocumentService from '../../../services/bioplus-services/document';
import DateUtils from '../../../utils/date-utils';
// import { FilterMenuFieldV2 } from '../../../Components/uielements/filterMenuField';
import { extractData, getDeclarationQuestions } from './logHelper';
import { ClosedEyeGray, DownloadIcon, EyeIcon } from '../../../Components/icons';
import { useCompany } from '../../../hooks/CompanyContext';
import DeclarationModal from './declarationModalView';
import { IntlMessages } from '../../../helper/langHelper';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { exportExcelFile } from '../../../helper/exportExcelHelper';

const getLogRecordsListBasedOnActiveTab = async (
  selectedTab,
  partnerId,
  companyFilter,
  startDate,
  endDate,
  page,
  pageSize
) => {
  if (selectedTab === 'Visited') {
    return await LogbookService.selfRecords(partnerId, page, pageSize);
  } else if (selectedTab === 'Guests') {
    return await LogbookService.listByPartner(
      partnerId,
      {
        companyId: companyFilter,
      },
      page,
      pageSize
    );
  }
};

const getReportDataBasedOnActiveTab = async (
  selectedTab,
  partnerId,
  companyFilter,
  startDate,
  endDate
) => {
  if (selectedTab === 'Visited') {
    return await LogbookService.selfRecordsReport(partnerId);
  } else if (selectedTab === 'Guests') {
    return await LogbookService.listByPartnerReport(partnerId, {
      companyId: companyFilter,
      fromDate: startDate,
      toDate: endDate,
    });
  }
};

const PartnerLogRecords = () => {
  const userContext = useUserContext();
  const companyContext = useCompany();

  const partnerId = userContext?.company?.partnerId;
  const companyFilter = companyContext?.company?._id;

  const { userPermission } = userContext;
  const isUserAllowToManage = userPermission?.find((permission) => permission?.label === 'logbook');

  const canDownloadReport = !!isUserAllowToManage?.isReport;

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [name, setName] = useState();
  const [startDate, setStartDate] = useState(DateUtils.last7Days);
  const [endDate, setEndDate] = useState(DateUtils.today);
  const [isDeclarationView, setIsDeclarationView] = useState(false);
  const [declarationData, setDeclarationData] = useState();
  const [selectedTab, setSelectedTab] = useState('Visited');
  const [isExportLoading, setIsExportLoading] = useState(false);

  // format language
  const intl = useIntl();
  const alertMessagedeclarationFailed = intl.formatMessage({
    id: 'help.text.declaration.error',
  });

  const query = useQuery(
    ['logBookEntries', partnerId, companyFilter, startDate, endDate, page, pageSize, selectedTab],
    () =>
      getLogRecordsListBasedOnActiveTab(
        selectedTab,
        partnerId,
        companyFilter,
        startDate,
        endDate,
        page,
        pageSize
      )
  );

  const tableData = query?.data?.data ?? query?.data ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  // const handleFilterParams = (filterParams) => {
  //   if (filterParams) {
  //     const { fromDate, toDate } = filterParams;
  //     setStartDate(fromDate);
  //     setEndDate(toDate);
  //   }
  // };

  //   table columns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.visitor.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>
            {`${cellData?.row?.original?.userId?.firstName} ${cellData?.row?.original?.userId?.lastName}`}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.account.owner" />,
        accessor: 'companyId.name',
      },
      {
        Header: <IntlMessages id="table.col.premise" />,
        accessor: 'premiseId.propertyName',
      },
      {
        Header: <IntlMessages id="table.col.geofence" />,
        accessor: 'geofenceId.name',
      },
      {
        Header: <IntlMessages id="table.col.service.role" />,
        accessor: 'serviceRole',
      },
      {
        Header: <IntlMessages id="table.col.entry.date" />,
        accessor: 'entryDate',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? moment(cellData.value).format('DD-MM-YYYY') : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.entry.time" />,
        accessor: 'entryDate',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? moment(cellData.value).format('h:mm:ss A') : '--'}
          </TableCell>
        ),
        id: 'entryTime',
      },
      {
        Header: <IntlMessages id="table.col.exit.time" />,
        accessor: 'exitDate',
        Cell: (cellData) => (
          <TableCell>
            {cellData.value ? moment(cellData.value).format('h:mm:ss A') : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="text.declaration" />,
        accessor: 'declaration',
        isAction: true,
      },
    ],
    []
  );

  const handleDeclarationLink = async (data) => {
    try {
      const content = await DocumentService.getDocument(data?.declarationId);
      const declarationContent = {
        ...content,
        geofenceName: data?.geofenceName,
        premise: data?.premiseName,
      };
      if (content && declarationContent) {
        // const declarationQuestionAnswer = getDeclarationQuestions(declarationContent);
        // if (declarationQuestionAnswer) {
        setDeclarationData(declarationContent);
        setIsDeclarationView(true);
        // }
      }
    } catch (error) {
      alert(alertMessagedeclarationFailed);
    }
  };

  const handleClosed = () => {
    setIsDeclarationView(false);
  };

  const handleSelectedTab = (selectedTab) => {
    setSelectedTab(selectedTab);
    setPage(0); // Reset to first page when changing tab
  };

  const actionList = [
    (data) => (
      <>
        {data?.declarationId ? (
          <IconButton onClick={() => handleDeclarationLink(data)}>
            <EyeIcon style={{ width: '18px', height: '18px' }} />
          </IconButton>
        ) : (
          <IconButton>
            <ClosedEyeGray style={{ width: '18px', height: '18px', color: 'red' }} />
          </IconButton>
        )}
      </>
    ),
  ];

  // Function to handle Excel export with all records
  const handleExcelExport = async () => {
    try {
      setIsExportLoading(true);

      // Fetch all records based on active tab
      const reportData = await getReportDataBasedOnActiveTab(
        selectedTab,
        partnerId,
        companyFilter,
        startDate,
        endDate
      );

      // Extract the data array - handle both data.data and data structures
      const allRecords = reportData?.data ? reportData.data : reportData;

      if (allRecords && Array.isArray(allRecords)) {
        const excelFormatData = extractData(allRecords);
        const fileName = `logRecords_${selectedTab}_${moment().format('YYYY-MM-DD')}.xlsx`;
        const columnConfig = [
          { header: 'Visitor Name', key: 'VisitorName', width: 30 },
          { header: 'Account Owner', key: 'Company', width: 30 },
          { header: 'premise Name', key: 'premiseName', width: 30 },
          { header: 'Geofence Name', key: 'Geofence', width: 30 },
          { header: 'Service Role', key: 'serviceRole', width: 30 },
          { header: 'Date', key: 'Date', width: 20 },
          { header: 'Entry Time', key: 'entryTime', width: 20 },
          { header: 'Exit Time', key: 'exitTime', width: 20 },
        ];

        exportExcelFile(excelFormatData, fileName, columnConfig);
      }
    } catch (error) {
      console.error('Error exporting Excel:', error);
      alert('Failed to export records. Please try again.');
    } finally {
      setIsExportLoading(false);
    }
  };

  if (query.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.records.logRecords" />
        </HeaderTitle>
        <TwoColumns style={{ gap: '10px' }}>
          {/* <TabButton
            buttonArray={[
              { buttonText: 'Visited', textId: '1', icon: <CheckIcon /> },
              { buttonText: 'Guests', textId: '2', icon: <GroupIcon /> },
            ]}
            onButtonClick={handleSelectedTab}
            selectedTab={selectedTab}
          /> */}
          {/* <FilterMenuFieldV2 handleFilterParams={handleFilterParams} isOnlyDate={true} /> */}

          {tableData && tableData.length > 0 && canDownloadReport && (
            <IconButtonWithText
              text={<IntlMessages id="button.text.downloadExcel" />}
              icon={<DownloadIcon />}
              onClick={handleExcelExport}
              disabled={isExportLoading}
            />
          )}
        </TwoColumns>
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={tableData}
          columns={userColumns}
          hasFooter={true}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={query?.data?.total || 0}
          actions={actionList}
        />
      </TableWrapper>
      {declarationData && (
        <DeclarationModal
          open={isDeclarationView}
          onClose={handleClosed}
          userData={declarationData}
        />
      )}
    </StyledContainer>
  );
};

export default PartnerLogRecords;
